import { AppPageLayout, type AppPageLayoutProps } from './AppPageLayout';
import type { SidebarConfig } from './types';
import { type UseAppPageLayoutOptions } from './useAppPageLayout';

export interface AppPageLayoutContainerProps
  extends Omit<AppPageLayoutProps, 'isChatInterface' | 'disableSidePadding' | 'sidebarConfig'>,
    UseAppPageLayoutOptions {
  /**
   * Sidebar configuration for app-specific behavior (icons, URLs, handlers, etc.)
   */
  sidebarConfig: SidebarConfig;
  /**
   * Optional app ID for navigation and section name resolution.
   * If not provided, the first allowedApps appId will be used as fallback.
   */
  appId?: string;
  /**
   * The intl message ID for the platform name (e.g., "appHeader.platform.name", "appHeader.platform.name.internal")
   */
  platformNameMessageId: string;
  /**
   * When true, the sidebar section-title labels are omitted (nav items and
   * dividers are kept). Forwarded to AppPageLayout via `...rest`.
   */
  // TODO: cleanup with cp_app_header_rename ff
  hideSectionTitles?: boolean;
}

/**
 * Container component that encapsulates layout behavior logic.
 * Uses the useAppPageLayout hook to determine chat interface and padding behavior
 * based on the current route, then passes these values to the presentational AppPageLayout.
 */
export const AppPageLayoutContainer = ({
  sidebarConfig,
  allowedApps,
  getSectionName,
  appId,
  platformNameMessageId,
  ...rest
}: AppPageLayoutContainerProps & { getSectionName?: (appId?: string) => string }) => {
  return (
    <AppPageLayout
      sidebarConfig={sidebarConfig}
      allowedApps={allowedApps}
      getSectionName={getSectionName}
      appId={appId}
      platformNameMessageId={platformNameMessageId}
      {...rest}
    />
  );
};
